import { FileTypeEnum as e } from "../../enums/file-type-enum.mjs";
import { getThumbnailByType as t } from "../../utils/get-thumbnail-by-type.mjs";
import n from "react";
import { twMerge as r } from "tailwind-merge";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/file-preview/index.tsx
var o = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), c = n.memo(({ src: c, fileType: l, alt: u, className: d, isThumbnail: f = !1, objectFit: p = "cover", width: m, height: h, title: g }) => {
	let [_, v] = n.useState(s.has(c)), [y, b] = n.useState(o.has(c));
	return /* @__PURE__ */ a("div", {
		className: r("flex items-center justify-center", d),
		style: {
			width: m,
			height: h,
			minHeight: h
		},
		title: g,
		children: [
			c && l !== e.Video ? /* @__PURE__ */ i("img", {
				src: c,
				alt: u,
				className: r("rounded-md", p === "contain" ? "shadow-3 max-h-full max-w-full object-contain" : "w-full flex-2 object-cover", f && p === "cover" && "h-full", !_ && y ? "block" : "hidden"),
				onLoad: () => {
					b(!0), o.add(c), s.delete(c);
				},
				onError: () => {
					v(!0), o.delete(c), s.add(c);
				}
			}) : null,
			c && l === e.Video ? /* @__PURE__ */ i("video", {
				src: c,
				className: r("rounded-md", p === "contain" ? "shadow-3 max-h-full max-w-full object-contain" : "w-full flex-2 object-cover", f && p === "cover" && "h-full", !_ && y ? "block" : "hidden"),
				onLoadedData: () => {
					b(!0), o.add(c), s.delete(c);
				},
				onError: () => {
					v(!0), o.delete(c), s.add(c);
				},
				controls: !f
			}) : null,
			/* @__PURE__ */ i("div", {
				className: r("flex flex-2 items-center justify-center rounded-md", !f && "min-h-[300px]", !c || _ ? "flex" : "hidden"),
				children: t(l)
			})
		]
	});
});
c.displayName = "FilePreview";
//#endregion
export { c as FilePreview };
